// =============================================================================
// PURCHASE PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'purchases',
  component: () => import('../../views/admin/purchases/index.vue'),
  children: [
    {
      path: '',
      redirect: '/error-404'
    },
    {
      path: 'invoices',
      component: () => import('../../views/admin/purchases/invoices/index.vue'),
      children: [
        {
          path: '',
          name: 'purchasesInvoices',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePurchasesInvoices" */ '@/mobile/views/admin/purchases/invoices/list/purchaseInvoicesList.vue') : import(/* webpackChunkName: "desktopPurchasesInvoices" */ '@/desktop/views/admin/purchases/invoices/list/purchaseInvoicesList.vue') },
          meta: {
            permission: 'purchase_invoice.show',
            pageTitle: 'فاکتورهای خرید',
            pageTitleI18n: 'pages.purchases.invoices.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'purchaseInvoicesTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePurchasesTrash" */ '@/mobile/views/admin/purchases/invoices/trash/purchaseInvoicesTrash.vue') : import(/* webpackChunkName: "desktopPurchasesTrash" */ '@/desktop/views/admin/purchases/invoices/trash/purchaseInvoicesTrash.vue') },
          meta: {
            permission: 'purchase_invoice.delete',
            pageTitle: 'سطل زباله فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'purchaseInvoiceTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePurchaseInvoiceTrashProfile" */ '@/mobile/views/admin/purchases/invoices/invoice/purchaseInvoice.vue') : import(/* webpackChunkName: "desktopPurchaseInvoiceTrashProfile" */ '@/desktop/views/admin/purchases/invoices/invoice/purchaseInvoice.vue') },
          meta: {
            permission: 'purchase_invoice.show',
            pageTitle: 'فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.invoice.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertPurchaseInvoice',
          component: () => import(/* webpackChunkName: "insertPurchaseInvoice" */ '../../views/admin/purchases/invoices/insert/insertPurchaseInvoice.vue'),
          meta: {
            permission: 'purchase_invoice.create',
            pageTitle: 'افزودن فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'purchaseInvoice',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePurchaseInvoice" */ '@/mobile/views/admin/purchases/invoices/invoice/purchaseInvoice.vue') : import(/* webpackChunkName: "desktopPurchaseInvoice" */ '@/desktop/views/admin/purchases/invoices/invoice/purchaseInvoice.vue') },
          meta: {
            permission: 'purchase_invoice.show',
            pageTitle: 'فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/activities-log',
          name: 'purchaseInvoiceActivitiesLog',
          component: () => import(/* webpackChunkName: "purchaseInvoiceActivitiesLog" */ '../../views/admin/purchases/invoices/activitiesLog/purchaseInvoiceActivitiesLog.vue'),
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.invoice.logs.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/edit',
          name: 'editPurchaseInvoice',
          component: () => import(/* webpackChunkName: "editPurchaseInvoice" */ '../../views/admin/purchases/invoices/edit/editPurchaseInvoice.vue'),
          meta: {
            permission: 'purchase_invoice.update',
            pageTitle: 'ویرایش فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.edit.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/return',
          name: 'insertReturnPurchaseInvoice',
          component: () => import(/* webpackChunkName: "insertReturnPurchaseInvoice" */ '../../views/admin/purchases/returnPurchase/insert/insertReturnPurchaseInvoice.vue'),
          meta: {
            permission: ['purchase_invoice.show', 'purchase_invoice.update', 'return_purchase_invoice.create'],
            pageTitle: 'افزودن فاکتور برگشت از خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.insert.title'
          // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'return-invoices',
      component: () => import('../../views/admin/purchases/returnPurchase/index.vue'),
      children: [
        {
          path: '',
          name: 'returnPurchaseInvoices',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnPurchasesInvoices" */ '@/mobile/views/admin/purchases/returnPurchase/list/returnPurchaseInvoicesList.vue') : import(/* webpackChunkName: "desktopReturnPurchasesInvoices" */ '@/desktop/views/admin/purchases/returnPurchase/list/returnPurchaseInvoicesList.vue') },
          meta: {
            permission: 'return_purchase_invoice.show',
            pageTitle: 'فاکتورهای مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'returnPurchaseInvoicesTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnPurchasesInvoiceTrash" */ '@/mobile/views/admin/purchases/returnPurchase/trash/returnPurchaseInvoicesTrash.vue') : import(/* webpackChunkName: "desktopReturnPurchasesInvoiceTrash" */ '@/desktop/views/admin/purchases/returnPurchase/trash/returnPurchaseInvoicesTrash.vue') },
          meta: {
            permission: 'return_purchase_invoice.delete',
            pageTitle: 'سطل زباله فاکتور مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'returnPurchaseInvoiceTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnPurchaseInvoiceTrashProfile" */ '@/mobile/views/admin/purchases/returnPurchase/invoice/returnPurchaseInvoice.vue') : import(/* webpackChunkName: "desktopReturnPurchaseInvoiceTrashProfile" */ '@/desktop/views/admin/purchases/returnPurchase/invoice/returnPurchaseInvoice.vue') },
          meta: {
            permission: 'return_purchase_invoice.show',
            pageTitle: 'فاکتور مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'returnPurchaseInvoice',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnPurchaseInvoice" */ '@/mobile/views/admin/purchases/returnPurchase/invoice/returnPurchaseInvoice.vue') : import(/* webpackChunkName: "desktopReturnPurchaseInvoice" */ '@/desktop/views/admin/purchases/returnPurchase/invoice/returnPurchaseInvoice.vue') },
          meta: {
            permission: 'return_purchase_invoice.show',
            pageTitle: 'فاکتور مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/activities-log',
          name: 'returnPurchaseInvoiceActivitiesLog',
          component: () => import(/* webpackChunkName: "returnPurchaseInvoiceActivitiesLog" */ '../../views/admin/purchases/returnPurchase/activitiesLog/returnPurchaseInvoiceActivitiesLog.vue'),
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های فاکتور مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.invoice.logs.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/edit',
          name: 'editReturnPurchaseInvoice',
          component: () => import(/* webpackChunkName: "editReturnPurchaseInvoice" */ '../../views/admin/purchases/returnPurchase/edit/editReturnPurchaseInvoice.vue'),
          meta: {
            permission: 'return_purchase_invoice.update',
            pageTitle: 'ویرایش فاکتور مرجوع خرید',
            pageTitleI18n: 'pages.purchases.returnInvoices.edit.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'suggest',
      name: 'suggestPurchaseInvoice',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSuggestPurchasesInvoices" */ '@/mobile/views/admin/purchases/suggest/purchaseSuggest.vue') : import(/* webpackChunkName: "desktopSuggestPurchasesInvoices" */ '@/desktop/views/admin/purchases/suggest/purchaseSuggest.vue') },
      meta: {
        permission: 'suggest_purchase_invoice.show',
        pageTitle: 'پیشنهاد فاکتور خرید',
        pageTitleI18n: 'pages.purchases.suggest.title'
        // rule: 'editor'
      }
    }
  ]
}
